import { CreateUserServiceTransactionInterface } from "../interfaces/UserServiceTransactionInterface/CreateUserServiceTransactionInterface";
import { UserServiceTransactionInterface } from "../interfaces/UserServiceTransactionInterface/UserServiceTransactionInterface";
import BaseService from "./BaseService";

export class UserServiceTransactionService extends BaseService<UserServiceTransactionInterface, CreateUserServiceTransactionInterface>{ 
    constructor(){
        let url: string = '/user-service-transaction/admin'
        super(url)
    }
}